import * as pdfjsLib from 'pdfjs-dist/webpack.mjs';

function createWrapper($q) {
  class PdfjsWrapper {
    getDocument(url) {
      return pdfjsLib.getDocument(url).promise;
    }
  }

  return new PdfjsWrapper();
}

export default createWrapper;
